import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Field, Formik } from "formik";
import ThirdPartyAdmin from "components/ThirdPartyAdmin";
import CoveredEntity from "components/CoveredEntity";
import Pharmacy from "components/Pharmacy";
import NDCList from "components/NDCList";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import API from "utils/API";
import { Option, LimitedChipsContainer } from "components/Options";
import useContextService from "hooks/useContextService";
import { default as ReactSelect } from "react-select";
import useAxios from "hooks/useAxios";
import { cloneDeep } from "lodash";
import Select from "react-select";
import reset from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";

import FormikInputField from "components/common/Fields/FormikInputField";

const initialValues = {
  coveredEntityID: "",
  pharmacyID: "",
  thirdPartyAdminID: "",
  ndc: "",
};

const validationSchema = Yup.object({
  thirdPartyAdminID: Yup.string().required(
    "Third Party Administrator is required"
  ),
});

let ceData = [];
let pharmacyData = [];
const SearchInventory = (props) => {
  const {
    states: { Inventory },
    setStates,
    resetStates,
  } = useContextService();
  const [ceDatalist, setCeDatalist] = useState([]);
  const { onSearch, onReset } = props;
  const [ceLoading, setCeLoading] = useState(false);
  // const[thirdPartyAdminID,setTpaID]=useState('');
  const [selectedTpa, setSelectedTpa] = useState({});
  const [ceList, setCEList] = useState([]);
  const [searchCEterm, setSearchCEterm] = useState("");
  const [selectedCE, setSelectedCE] = useState(null);
  const [phList, setPHList] = useState([]);
  const [searchPHterm, setSearchPHterm] = useState("");
  const [selectedPH, setSelectedPH] = useState(null);
  const [selectedNdc, setSelectedNdc] = useState("");
  const [selectedOpt, setOptSelected] = useState({ optSelected: "-1" });
  const [selectedOption, setOptionSelected] = useState({
    optionSelected: "-1",
  });
  const { thirdPartyAdmin, searchTerms, coveredEntity, pharmacy } = Inventory;

  const {
    thirdPartyAdminID,
    // coveredEntityID,
    // pharmacyID,
  } = searchTerms;

  const updateStates = (Inventory) => {
    setStates("Inventory", Inventory);
  };

  useEffect(() => {
    Inventory.thirdPartyAdmin = {};
    Inventory.coveredEntity = null;
    Inventory.pharmacy = null;
    resetStates("Inventory");
  }, []);

  const handleThirdPartyAdminChange = async (value, setFieldValue, tpa) => {
    setOptionSelected({ optionSelected: "-1" });
    Inventory.searchTerms.ceIds = {};
    Inventory.searchTerms.pharmacyids = {};
    setCeDatalist([]);
    pharmacyData = [];
    ceData = [];
    setOptSelected({ optSelected: "-1" });
    const { thirdPartyAdminID } = tpa;
    fetchCoveredEntities(thirdPartyAdminID);
    fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    if (tpa) {
      const { thirdPartyAdminID } = tpa;
      setFieldValue("thirdPartyAdminID", value);
      Inventory.coveredEntity = "";
      Inventory.searchTerms.coveredEntityID = "";
      Inventory.pharmacy = "";
      Inventory.searchTerms.pharmacyID = "";
      Inventory.thirdPartyAdmin = tpa;
      Inventory.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
    } else {
      setFieldValue("thirdPartyAdminID", "");
      Inventory.coveredEntity = "";
      Inventory.searchTerms.coveredEntityID = "";
      Inventory.pharmacy = "";
      Inventory.searchTerms.pharmacyID = "";
      Inventory.thirdPartyAdmin = {};
      Inventory.searchTerms.thirdPartyAdminID = "";
      pharmacyData = [];
      ceData = [];
    }
    updateStates(Inventory);
  };
  const fetchPharmacyNamesByTpaID = async (thirdPartyAdminID) => {
    pharmacyData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/GetPharmaciesByTpaId/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchPharmacyNames = async (selected) => {
    let payloads = [];
    pharmacyData = [];
    for (var x in selected) {
      var rw = selected[x];
      payloads.push(rw.value);
    }
    let payload = {};
    payload.CoveredIDS = payloads;
    try {
      const { data } = await API.post(
        `GWConfig/coveredentity/Pharmacieslist/${thirdPartyAdminID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchCoveredEntities = async (thirdPartyAdminID) => {
    setCeDatalist([]);
    ceData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          ceData.push({ value: data[x].id, label: data[x].description });
        }
        setCeDatalist(ceData);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleCEChange = (selected) => {
    if (selected.length !== 0) {
      setOptSelected({
        optSelected: -1,
      });
    }
    if (selected.length === 0) {
      fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    }
    pharmacyData = [];
    setOptionSelected({
      optionSelected: selected,
    });
    Inventory.searchTerms.ceIds = selected;
    updateStates(Inventory);
    fetchPharmacyNames(selected);
  };

  const handleReset = ({ resetForm }) => {
    resetForm();
    onReset();
    resetStates("Inventory");
    setOptionSelected({ optionSelected: "-1" });
    Inventory.searchTerms.ceIds = {};
    Inventory.searchTerms.pharmacyids = {};
    setCeDatalist([]);
    pharmacyData = [];
    ceData = [];
    setSelectedNdc("");
    setOptSelected({ optSelected: "-1" });
  };

  const handleNdc = (ndc, setFieldValue) => {
    if (ndc) {
      setSelectedNdc(ndc);
      setFieldValue("ndc", ndc.id);
      Inventory.searchTerms.ndc = ndc;
      updateStates(Inventory);
    } else {
      setSelectedNdc("");
      setFieldValue("ndc", "");
      Inventory.searchTerms.ndc = {};
      updateStates(Inventory);
    }
  };

  const handlepharmacyChange = (selected) => {
    setOptSelected({
      optSelected: selected,
    });
    Inventory.searchTerms.pharmacyids = selected;
    updateStates(Inventory);
  };

  const handleSubmit = async (val, actions) => {

    let coveredEntityIDS = [];
    for (var x in selectedOption.optionSelected) {
      var n = selectedOption.optionSelected[x].value;
      coveredEntityIDS.push(n);
    }
    let pharmacyIDS = [];
    for (var x in selectedOpt.optSelected) {
      var rw = selectedOpt.optSelected[x].value;
      pharmacyIDS.push(rw);
    }
    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    if (thirdPartyAdminID) values.thirdPartyAdminID;
    if (coveredEntityIDS > [0]) values.coveredEntityIDS = coveredEntityIDS;
    if (pharmacyIDS > [0]) { values.pharmacyIDS = pharmacyIDS; }
    else {
      values.pharmacyIDS = [];
    }
    if (selectedNdc) values.ndc = selectedNdc;
    Inventory.search.currentPage = 1;
    updateStates(Inventory);
    // console.log(values, "values");
    await onSearch(values);
    setSubmitting(false);
  };

  useEffect(() => {
    pharmacyData = [];
  }, [])
  useEffect(()=>{
     onReset();
    resetStates("Inventory");
    setOptionSelected({ optionSelected: "-1" });
    Inventory.searchTerms.ceIds = {};
    Inventory.searchTerms.pharmacyids = {};
    setCeDatalist([]);
    pharmacyData = [];
    ceData = [];
    setSelectedNdc("");
    setOptSelected({ optSelected: "-1" });
  },[])

  return (
    <Formik
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
      initialValues={searchTerms}
      children={(props) => {
        const {
          isSubmitting,
          handleSubmit,
          resetForm,
          setFieldValue,
          errors,
          touched,
        } = props;
        return (
          <div>
            <h5 className="f-15 text-primary font-weight-700">Search Accumulations</h5>
            <Row>
              <Col md={3} sm={3} xs={3}>
                {" "}
                <FormGroup>
                  <Label for="tpa">Third Party Administrator</Label>
                  <ThirdPartyAdmin
                    value={thirdPartyAdminID}
                    name="thirdPartyAdminID"
                    onChange={(value, tpa) =>
                      handleThirdPartyAdminChange(value, setFieldValue, tpa)
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="coveredEntity">Covered Entity</Label>
                  {/* <CoveredEntity
                  thirdPartyAdminID={thirdPartyAdminID}
                  onSelect={(value)=>onSelectCE(value,setFieldValue)}
                  selectedCE={selectedCE}
                  /> */}
                  <ReactSelect
                    name="ceDatalist"
                    options={ceDatalist}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handleCEChange}
                    value={selectedOption.optionSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option : (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
                {" "}
                <FormGroup>
                  <Label for="pharmacy">Pharmacy</Label>
                  {/* <Pharmacy
                  thirdPartyAdminID={thirdPartyAdminID}
                  coveredEntityID={selectedCE?.id}
                  onSelect={(value)=>onSelectPH(value,setFieldValue)}
                  selectedPH={selectedPH}
                  /> */}
                  <ReactSelect
                    name="pharmacyData"
                    options={pharmacyData}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handlepharmacyChange}
                    value={selectedOpt.optSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option : (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />

                  {errors.pharmacyID && touched.pharmacyID ? (
                    <div className="text-danger f-10 position-absolute">
                      {errors.pharmacyID}
                    </div>
                  ) : null}
                </FormGroup>
              </Col>{" "}
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="drugnamendc">Drug Name/NDC</Label>
                  <NDCList
                    onSelect={(value) => handleNdc(value, setFieldValue)}
                    selectedNDC={selectedNdc}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="d-flex justify-content-end">
              <Col md="auto" className="">
                <Label>{""}</Label>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="search"
                >
                  <span className="right_5">
                    <img src={searchicon} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button className="reset" color="primary" onClick={() => handleReset(props)}>
                  <span className="right_5">
                    <img src={reset} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>
            </Row>
          </div>
        );
      }}
    ></Formik>
  );
};

export default SearchInventory;
